import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ColoriSvgResponse, GenericDD, GenericGroupedDD} from '../model/generic-data';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DropdownServiceService {

  private url:string=environment.apiUrl+'/dropdowns';

  constructor(
    private http: HttpClient
  ) { }

  GoToSleep(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/test/sleep`)
  }

  MDTipoMezzodd(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/tipo-mezzo`);
  }

  MDAccessori(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${environment.apiUrl}/accessori/get/all/dd`);
  }

  AnagraficheFornitore(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${environment.apiUrl}/anagrafiche/fornitori/get/all/dd`);
  }

  AnagraficheCliente(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${environment.apiUrl}/anagrafiche/clienti/get/all/dd`);
  }

  DDTipoAlimentazione(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/tipoalimentazione`);
  }

  DDTipoContratto(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/tipocontratto`);
  }

  MDCondizioniPagamento(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/condizioni-pagamento`);
  }


  MDServiziDD(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/servizicontratti`);
  }

  DocumentiTipologia(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/tipologia-documento`);
  }

  TipologiaConsegna(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/tipologia-consegna`);
  }

  V2AnagraficheClienti(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/clienti`);
  }

  DDComuniTest(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/province/all`);
  }


  GenericDD(urlString:string): Observable<GenericDD[]> {
    if(urlString.startsWith('-')) {
      urlString = urlString.substring(1);
      return this.http.get<GenericDD[]>(`${environment.apiUrl}/${urlString}`);
    }else{
      return this.http.get<GenericDD[]>(`${this.url}/${urlString}`);
    }    
  }

  GenericDDDelete(urlString: string, id: string | number): Observable<void> {
    if (urlString.startsWith('-')) {
      urlString = urlString.substring(1);
      return this.http.delete<void>(`${environment.apiUrl}/${urlString}/${id}`);
    } else {
      return this.http.delete<void>(`${this.url}/${urlString}/${id}`);
    }
  }

  GenericDDPost(urlString:string,requestBody:any[]): Observable<Array<GenericDD>> {
    return this.http.post<Array<GenericDD>>(`${this.url}/${urlString}`,requestBody);
  }

  // GetProvince(): Observable<Array<GenericDD>> {
  //   return this.http.post<Array<GenericDD>>(`${this.url}/zone/dropdown/get/province/string`);
  // }
  GenericDDCountPost(urlString:string,requestBody:any[],filter:string): Observable<number> {
    return this.http.post<number>(`${this.url}/${urlString}/count/${filter}`,requestBody);
  }

  GenericDDCount(urlString:string): Observable<number> {
    return this.http.get<number>(`${this.url}/${urlString}/count`);
  }


  V2MDFiliali(idCliente: number): Observable<Array<GenericGroupedDD>> {
    return this.http.get<Array<GenericGroupedDD>>(`${this.url}/filiali/${idCliente}`);
  }

  V2MDNaturaMerce(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/natura-merce`);
  }

  V2Fornitori(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/fornitori`);
  }

  SimpleFiliali(): Observable<Array<GenericDD>> { 
    return this.http.get<Array<GenericDD>>(`${this.url}/filiali`);
  }

  SediCliente(idCliente: number): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/sedi/cliente/${idCliente}`);
  }


  UserDataClienti(filter?: string): Observable<Array<GenericDD>> {
    let url = `${this.url}/user/clienti`;
    if(filter != null) {
      url = url + `?type=${filter}`;
    }
    return this.http.get<Array<GenericDD>>(url);
  }

  UserDataDipendenti(): Observable<Array<GenericDD>> {
    return this.http.get<Array<GenericDD>>(`${this.url}/users/dipendenti`);
  }

  AnagraficheClientiFilter(filter?: string): Observable<Array<GenericDD>> {
    let url = `${this.url}/anagrafiche/clienti/filter`;
    if(filter != null ) {
      url = url +`?type=${filter}`;      
    }
    return this.http.get<Array<GenericDD>>(url);
  }

  GetColorORSVG(idMazzetta?: number): Observable<Array<ColoriSvgResponse>> {
    let uri = `${this.url}/colori-svg`;

    if(idMazzetta != undefined) {
      uri = uri +`?idMazzetta=${idMazzetta}`;
    }

    return this.http.get<Array<ColoriSvgResponse>>(uri);
  }

  //ITEM SELECTOR API WITH INFINITE SCROLL PAGINATION
  GenericDDWithIsc(urlString:string, offset:number, max:number,filter?:string): Observable<GenericDD[]> {

    return this.http.get<GenericDD[]>(`${this.url}/${urlString}?offset=${offset}&max=${max}${filter}`);

  }

}
